export const getTemplatesRoute = '/ext/ss/templates/';
export const getSignedTemplatesRoute = '/ext/ss/templates/application/';
export const sendReminderRoute = '/ext/ss/templates/application/reminder/';
export const resendDocumentRoute = '/ext/ss/templates/application/resend/';
export const sendOnboardingDocumentsRoute = '/employer/onboarding/documents/verify/';
export const downloadAllDocumentsRoute = '/ss/templates/downloads/archive/';
export const requestTemplateRoute = '/ext/ss/templates/request/';
export const addPayrollPartnerRoute = '/employer/onboarding/partner/create/';
export const addNewHireContactRoute = '/employer/notification/contacts/add/';
export const updatePayrollPartnerRoute = '/employer/onboarding/partner/update/';
export const updatedNewHireContactRoute = '/employer/notification/contacts/update/';
export const deletePayrollPartnerRoute = '/employer/onboarding/partner/delete/';
export const deleteNewHireContactRoute = '/employer/notification/contacts/delete/';
export const onboardingPartnersListRoute = '/employer/onboarding/partner/';
export const newHireContactListRoute = '/employer/notification/contacts/get/';
export const onboardingPackagesListRoute = '/ext/ss/templates/get';
export const onboardingOldPackagesListRoute = '/employer/onboarding/old/partner/';
export const onBoardingPackagaeRoute = '/ext/ss/templates/update/';
export const onBoardingPackagaeDeleteRoute = '/ext/ss/templates/delete/';
export const sendDocumentRoute = '/employer/applicants/doc-send/';

//enterprise Routes
export const getCompanyDocsRoute = '/enterprise/onboarding/get/templates';
export const updateCompanyPayrollPartnerRoute = '/enterprise/onboarding/partner/old/update/';

